var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64325 8.77378C8.08437 5.97649 12.3723 4.11776 14.5255 3.216C20.6538 0.657957 21.942 0.216279 22.7701 0.197876C22.9542 0.197876 23.359 0.234683 23.6351 0.455521C23.8559 0.639553 23.9111 0.878796 23.9479 1.06283C23.9848 1.24686 24.0216 1.63333 23.9848 1.92778C23.6535 5.42439 22.218 13.9083 21.4819 17.8098C21.1691 19.466 20.5618 20.0181 19.9729 20.0734C18.6846 20.1838 17.7093 19.2268 16.4762 18.4171C14.5255 17.1472 13.4397 16.3559 11.5442 15.1045C9.3542 13.669 10.7712 12.8777 12.0227 11.5895C12.3539 11.2582 18.0037 6.10531 18.1141 5.64523C18.1325 5.59002 18.1325 5.36918 18.0037 5.25876C17.8749 5.14834 17.6909 5.18515 17.5436 5.22195C17.3412 5.25876 14.2495 7.31992 8.2316 11.387C7.34825 11.9943 6.55691 12.2888 5.83918 12.2704C5.04784 12.252 3.53878 11.8287 2.39778 11.4606C1.01754 11.019 -0.0866539 10.7797 0.00536217 10.0068C0.0605718 9.60192 0.612668 9.19705 1.64325 8.77378Z",
    fill: "#EFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.365bb7281b28d10d9a2472fd0433c5d9.svg";
export { ForwardRef as ReactComponent };